<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">افزودن هاست</strong>
                <strong v-else>ویرایش هاست</strong>
              </CCol>
              <CCol col="4" style="text-align: center ;">

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  افزودن
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                 ویرایش
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  انصراف
                </CButton>

                <a :href="$route.fullPath" target="_blank">
                  <CButton
                          class="mr-1 ml-1"
                          size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>
          <CRow>

            <CCol col="12">
              <CCardBody>
                <CRow>
                  <CCol col="3">
                    <CInput
                        label="نام هاست"

                        v-model="name"
                    />
                  </CCol>
                  <CCol col="3">
                    <CTextarea
                        label="توضیحات هاست"

                        v-model="summary"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="قیمت"

                        v-model="price"
                    />
                  </CCol>
                  <CCol col="3">
                    <CInput
                        label="قیمت قدیم"

                        v-model="old_price"
                    />
                  </CCol>

                  <CCol col="3">
                    <CInput
                        label="نام پکیج در سرور"

                        v-model="package_name"
                    />
                  </CCol>


                </CRow>
                <CRow v-for="option in options">
                  <CCol col="4">
                    <CInput label="توضیحات" v-model="option.name"/>

                  </CCol>
<!--                  <CCol col="4">-->
<!--                    <CInput label="مقدار ایتم" v-model="option.value"/>-->

<!--                  </CCol>-->
                  <CCol col="2">
                    <CButton outline color="dark" @click="options.push({name:'',value:''})">+</CButton>
                    <CButton v-if="options.length>1" outline color="dark" @click="options.splice(index,1)">-</CButton>
                  </CCol>

                </CRow>
              </CCardBody>

            </CCol>
            <CCol col="12">
              <CRow >
                <CCol md="6">
                  <CCard>
                    <CCardHeader>
                      <strong>لیست هاست ها</strong>
                    </CCardHeader>
                    <CCardBody>
                      <CDataTable
                          :items="items"
                          :fields="fields"
                          @row-clicked="table_row_clicked"

                          :items-per-page="10"
                          hover
                          sorter
                          striped
                          border
                          column-filter
                          pagination
                      >
                        <template #row="{item,index}">

                          <td style="text-align: center">
                            <p >{{ index + 1 }}</p>

                          </td>

                        </template>

                        <template #operation="{item}">
                          <td>
<!--                            <CIcon @click.native="goSubCategories(item)" class="mr-1 text-success"-->
<!--                                   name="cilApplications"/>-->

<!--                            <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                            <CIcon @click.native="delete_item_dialog(item)" class="mr-1 text-danger" name="cilTrash"/>

                          </td>
                        </template>


                      </CDataTable>
                    </CCardBody>

                  </CCard>
                </CCol>
              </CRow>

            </CCol>

          </CRow>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm_brand" + new Date().getTime() + "_" + this.$vnode.tag,
      edit_name:'',
      name: '',
      summary: '',
      price: '',
      old_price: '',
      package_name: '',
      color: '#ffffff',
      previewImage: '/img/placeholder.png',
      description: '',
      items: [],
      table_clicks:0,
      table_clicks_timer:null,
      options:[{name:'',value:''}],
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:10%'},
        {key: 'name', label: "نام", _style: 'width:20%'},
        {key: 'price', label: "قیمت فعلی", _style: 'width:20%;'},
        {key: 'old_price', label:"قیمت قدیم", _style: 'width:20%;'},
        {key: 'package_name', label: "نام پکیج", _style: 'width:20%;'},
        {key: 'operation', label: "", filter: false, _style: 'width:10%;'},
      ],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }

    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' ) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      this.edit_name = item.brandName;
      this.name = item.brandName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = this.$root.base_url+'/'+item.imageName;
      this.status_form = item.id;

    },
    get_lists() {
      var self = this;
      console.log("route id " + this.$route.params.cat_id);

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.get('/hosts', {
        params: {
          // isparent : self.$route.params.cat_id
        },

      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
          self.items = content_data.map((item, row_id) => {
            return {...item, row_id}
          });


      })
          .catch(function (error) {

            console.log(error);
          });

    },


    insert_data() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "hosts";
      } else {
        url = "EditBrand";
        formData.append('id', this.status_form)
      }

      formData.append('summary', this.summary);
      formData.append('name', this.name);
      formData.append('price', this.price);
      formData.append('old_price', this.old_price);
      formData.append('extra_json', JSON.stringify(this.options));
      formData.append('package_name', this.package_name);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '/img/placeholder.png';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);
        bus.$emit('close_add_base_modal', 'false');

      })
          .catch(function (error) {
            console.log(error);
          });

    }, delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
